import { TrailerToolPanel } from "../TrailerToolPanel";
import { DataSource, Layout, LayoutHeader, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutTrailerList extends Layout {
    layoutTrailerTools: TrailerToolPanel;
    layoutheaderTrailerList: LayoutHeader;
    panelTrailerList: Panel;
    sourceTrailer: DataSource;
    tableTrailers: Table;
}
